export default __webpack_public_path__ + "static/media/clock.b1639c10.svg";